export const API_URL = 'https://api.especializati.com.br'
export const TOKEN_NAME = 'oautheti'